import { Direction } from "@common/constans";
import { FlightPoint, IOriginDestination } from "@common/models";
import { CabinClass } from "@common/models/AvailabilityRequest";
import Divider from "@components/general/Divider";
import Icon from "@components/general/Icon";
import { IAppState } from "@misc/State";
import Translate from "@service/Translate";
import { formatToDateTime, getAirport, minToMinHour } from "@utilize/Format";
import { FC, Fragment } from "react";
import { useSelector } from "react-redux";

interface IFlightDetailsResponsiveProps {
    flights: IOriginDestination[];
}

const FlightDetailsResponsive: FC<IFlightDetailsResponsiveProps> = ({ flights }) => {
    const { tr } = Translate;
    const { fleets } = useSelector((state: IAppState) => ({ fleets: state.fleets }));

    return (
        <div className="itinerary-flight-details-responsive">
            {
                flights.map((flight, index) =>
                    <Fragment key={index}>
                        <div className="segment-item">
                            <div className="segment-item-flight-detail">
                                <div className="row flex segment-direction">
                                    <div className="col-1-1">
                                        {
                                            flights.length === 2 && flights[0].origin?.code === flights[1].destination?.code ?
                                                tr(index ? "flight_return" : "flight_departure") :
                                                tr("flight_from_to", getAirport(flight.origin.code).cityName, getAirport(flight.destination.code).cityName)
                                        }
                                    </div>
                                </div>
                                <div className="row flex">
                                    <div className="col-1-1 flex">
                                        <div className="flight-city-name">{getAirport(flight.origin.code).cityName}</div>
                                        <div className="flight-airport-name">{`${getAirport(flight.origin.code).airportName} (${flight.origin.code})`}</div>
                                        <div className="flight-airport-terminal">{new FlightPoint(flight.origin).getDefaultTerminal(Direction.Departure, flight.destination?.code || "")?.displayText}</div>
                                    </div>
                                    {
                                        flight?.flightSegments?.map((flightSegment, index) => {
                                            const aircraftModel = fleets.find(f => f.itineraryCode?.toLowerCase() === flightSegment.equipmentModelInfo?.toLowerCase());

                                            return (
                                                <Fragment key={index}>
                                                    <div className="col-1-1">
                                                        <div className="segment-container">
                                                            <Icon name="icon-airplane-takeoff" flipRtl />
                                                            <div className="segment-origin flex">
                                                                <div className="departure-time">{formatToDateTime(flightSegment.departureDateTime!, { format: "H:i" })}</div>
                                                                <div className="departure-date">{formatToDateTime(flightSegment.departureDateTime!, { format: "l d M" })}</div>
                                                            </div>
                                                            <div className="segment-detail flex">
                                                                <div className="row flex flex-grow">
                                                                    <div className="col-1-1 segment-detail-items">{`${tr("flight_duration")}: `}{minToMinHour(flightSegment.journeyDuration || 0)}</div>
                                                                    <div className="col-1-1 segment-detail-items">{`${tr("flight_no")}: ${flightSegment.flightNumber}`}</div>
                                                                    <div className="col-1-1 segment-detail-items">
                                                                        {`${tr("aircraft_model")}: ${aircraftModel ? aircraftModel.displayText : ""}`}
                                                                    </div>
                                                                    <div className="col-1-1 segment-detail-items">
                                                                        {`${tr("calss_of_service")}: ${tr(`cabin_class_${CabinClass[flight.classOfService].toLowerCase()}`)}`}
                                                                    </div>
                                                                    <div className="col-1-1 segment-detail-items">{`${tr("free_baggage")}: ${flight.fareRules && flight.fareRules[0] ? tr("units_kg_value", flight.fareRules[0].freeBaggage) : ""}`}</div>
                                                                </div>
                                                            </div>
                                                            <div className="segment-destination flex">
                                                                <div className="arrival-time">{formatToDateTime(flightSegment.arrivalDateTime!, { format: "H:i" })}</div>
                                                                <div className="arrival-date">{formatToDateTime(flightSegment.arrivalDateTime!, { format: "l d M" })}</div>
                                                            </div>
                                                            <Icon name="icon-airplane-landing" flipRtl />
                                                        </div>
                                                    </div>
                                                    {
                                                        flight?.stops && index < flight.flightSegments.length - 1 ?
                                                            <div className="col-1-1 flex flex-center stop">
                                                                <div className="flight-city-name">{getAirport(flight.stops[index].airport.code).cityName}</div>
                                                                <div className="flight-airport-name">{`${getAirport(flight.stops[index].airport.code).airportName} (${flight.stops[index].airport.code})`}</div>
                                                                <div className="flight-airport-terminal">{new FlightPoint(flight.stops[index].airport).getDefaultTerminal(Direction.Departure)?.displayText}</div>
                                                                <div className="flight-stop-duration flex flex-center">
                                                                    <Icon name="icon-alert-outline" />
                                                                    {`${tr("stop_duration_in_city", getAirport(flight.stops[index].airport.code).cityName)}: `}{minToMinHour(flight.stops[index].duration)}
                                                                </div>
                                                            </div> : ""
                                                    }
                                                </Fragment>
                                            )
                                        }
                                        )
                                    }
                                    <div className="col-1-1 flex">
                                        <div className="flight-city-name">{getAirport(flight.destination.code).cityName}</div>
                                        <div className="flight-airport-name">{`${getAirport(flight.destination.code).airportName} (${flight.destination.code})`}</div>
                                        <div className="flight-airport-terminal">{new FlightPoint(flight.destination).getDefaultTerminal(Direction.Arrival, flight.origin?.code || "")?.displayText}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            index !== flights.length - 1 ?
                                <Divider mode="perforation" orientation="horizontal" varient="box-shadow" /> : ""
                        }
                    </Fragment>
                )
            }
        </div>
    )
}

export default FlightDetailsResponsive;